import { Pipe, PipeTransform } from "@angular/core";
import { BaseDto } from "@app/_models/_DTOs/baseDto";

@Pipe({
    name: 'notInSelectedItems',
    pure: false
})
export class NotSelectedItems<T extends BaseDto> implements PipeTransform {
    transform(value: T[], selectedItems: T[]): any {
        if (selectedItems && selectedItems.length > 0){
            return value.filter(item => {
                return !selectedItems.some(x => x.id == item.id);
            });
        }
        return value;
    }
}